/**
 * Throttle a function to only run every n milliseconds.
 *
 * Supports leading and trailing invocation.
 */
export default (function (func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var ctx;
  var throttleArgs;
  var rtn;
  var timer;
  var last = 0;

  var call = function call() {
    timer = 0;
    last = +new Date();
    rtn = func.apply(ctx, throttleArgs);
    ctx = null;
    throttleArgs = null;
  };

  return function throttle() {
    ctx = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    throttleArgs = args;
    var delta = new Date() - last;

    if (!timer) {
      if (delta >= wait) {
        call();
      } else {
        timer = setTimeout(call, wait - delta);
      }
    }

    return rtn;
  };
});